import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ToastController, ModalController } from 'ionic-angular';
import { GN } from '../../../../gn';
import { DIC } from '../../../dic';

/**
 * Generated class for the ChooseprocessesPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-chooseprocesses',
  templateUrl: 'chooseprocesses.html',
})
export class ChooseprocessesPage {
  cb: any
  selProcId = []
  arrayData = []
  Data = []
  values: Array<string> = [];
  arrayCheckedTmp = []
  cons: any;
  idxMaster = -1;

  constructor(public navCtrl: NavController, public navParams: NavParams, public gn: GN, public dic: DIC, public popoverCtrl: PopoverController, public toastCtrl: ToastController, public modalCtrl: ModalController) {
    this.selProcId = this.navParams.get("selProcId")
    this.arrayData = this.navParams.get("arrayData")
    this.cb = navParams.get('cb')
    this.cons = navParams.get('cons')
    this.idxMaster = navParams.get('idxMaster')
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ChooseprocessesPage');
    for (var i = 0; i < this.arrayData.length; i++) {
      var ch = false
      for (var j = 0; j < this.selProcId.length; j++) {
        if (this.selProcId[j] + '' == this.arrayData[i].id + '') {
          ch = true
        }
      }
      if (!ch)
        this.Data.push({ id: this.arrayData[i].id, name: this.arrayData[i].name, ch: ch, visible: true, selected: this.arrayData[i].selected })
    }
  }

  confirmProcesses() {
    this.cb(this.arrayCheckedTmp, this.cons, this.idxMaster)
    this.navCtrl.pop()
  }

  changeProcess(_p, _from) {
    if (_p.ch || _from == 'cons') {
      if (_from == 'cons') {
        this.arrayCheckedTmp = []
      }
      this.arrayCheckedTmp.push({ id: _p.id, name: _p.name, flag: _p.ch, cons: this.cons })
    } else {
      if (this.arrayCheckedTmp.length > 0) {
        for (let j = 0; j < this.arrayCheckedTmp.length; j++) {
          if (_p.id == this.arrayCheckedTmp[j].id) {
            this.arrayCheckedTmp.splice(j, 1)
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/agrculture/chooseprocesses/chooseprocesses.ts